export const DEFAULT_DOWNLOAD_NOT_ALLOWED_TOOLTIP = 'You do not currently own this product. Please contact Sales.';
